import { publicPath } from "@/lib/seo";
import { t, useLanguage } from "@/lib/i18n";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Building2, Mail, Phone, User } from "lucide-react";

const contactDetails = [
  { label: "Company", value: "KDAxiom", icon: Building2 },
  { label: "Contact number", value: "8800983400", icon: Phone, href: "tel:8800983400" },
  { label: "Contact email", value: "kuldeep.birthlia@gmail.com", icon: Mail, href: "mailto:kuldeep.birthlia@gmail.com" },
];

export default function Contact() {
  const language = useLanguage();
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen parchment-grain">
      <header className="bg-[#2C1E16] text-amber-50">
        <div className="max-w-7xl mx-auto px-5 min-h-16 py-4 flex flex-wrap items-center justify-between gap-4">
          <Link to={publicPath("/", language)} className="inline-flex items-center gap-2 text-sm text-amber-100 hover:text-[#D4A359]">
            <ArrowLeft size={16} aria-hidden="true" />{t(" Back to home")}</Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-5 py-16 sm:py-24">
        <p className="text-xs font-mono uppercase tracking-[0.2em] text-amber-800">{t("Get in touch")}</p>
        <h1 className="font-serif text-4xl sm:text-5xl font-bold text-stone-900 mt-3">{t("Contact Info")}</h1>
        <p className="mt-4 text-stone-600">{t("Contact the website owner using the details below.")}</p>
        <dl className="mt-10 bg-white border border-[#E6DEC3] rounded-2xl shadow-sm divide-y divide-[#E6DEC3]">
          {contactDetails.map(({ label, value, icon: Icon, href }) => (
            <div key={label} className="flex items-start gap-4 p-5 sm:p-7">
              <div className="shrink-0 rounded-xl bg-[#F4EFEB] p-3 text-amber-800">
                <Icon size={22} aria-hidden="true" />
              </div>
              <div className="min-w-0">
                <dt className="text-sm text-stone-500">{t(label)}</dt>
                <dd className="mt-1 text-lg font-semibold text-stone-900 break-words">
                  {href ? <a href={href} className="underline decoration-[#D4A359] underline-offset-4 hover:text-amber-800">{value}</a> : value}
                </dd>
              </div>
            </div>
          ))}
        </dl>
      </main>
    </div>
  );
}
